module.exports = __webpack_public_path__ + "img/27_62.832417e5.png";